import {BaseService, Command, config, loadApi, websocket} from "@systempiloten/react-lib";
import "material-symbols/outlined.css";
import ReactDOM from "react-dom/client";
import React from "react";
import "./styles/index.css";
import "./styles/buttons.css"
import "./styles/inputs.css"
import "./styles/MV.css"
import "./styles/quill.css"
import "./styles/scrollbar.css"
import "./styles/selects.css"
import "./styles/backgrounds.css"
import "./styles/icons.css"

import "./i18n";

window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/service-worker.js");
    }
});

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
(async () => {
    await fetch("/configuration.json")
        .then((res) => res.json())
        .then((data) => config.load(data))
        .catch((e) => null);
    BaseService.credentials.get("default").baseUrl = config.get("backend");
    await loadApi().catch(() => void 0);
    try {
        websocket.connect();
        websocket.cmd(Command.SyncProgressState,{})
    } catch (e) {

    }
    const {default: App} = await import("./App");
    root.render(<App/>);
})();
